import React from 'react';
import PropTypes from 'prop-types';
import '../../../../styles/WhyMMT.css';

const WhyMMT = ({ data }) => {
  return (
    <div className="rlWhyMmmt">
      <div className="wrapper">
        <div className="rlWhyMmmt__list">
          {data &&
            data.length > 0 &&
            data.map(({ id, heading, description }) => (
              <div key={id} className="rlWhyMmmt__list--item">
                <h4>{heading}</h4>
                <p>{description}</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

WhyMMT.propTypes = {
  data: PropTypes.array
};

export default WhyMMT;
